import { setProblemAsCompleted, setLessonAsCompleted } from "../../../../services/userService";

export function CheckCode(studentCode, output, checkboxes, user, lessonID) {

    const expectedCode1 = /\/\/\s*This prints a message to the screen\.\s*\n\s*System\.out\.println\("This will be printed."\);/; // P1: Single-line comment above print
    const expectedCode2 = /\/\*\s*This program prints a greeting message\.\s*\n\s*It demonstrates how to use multi-line comments in Java\.\s*\*\//; // P2: Multi-line comment at the top
    const expectedCode3 = /\/\/\s*System\.out\.println\("This should not be printed."\);/; // P3: Third print statement commented out


    if (checkboxes.checkbox1 === false) {
        const testResult = expectedCode1.test(studentCode)
        if (testResult) {
            setProblemAsCompleted(lessonID + "P1", user.uid);
            checkboxes.checkbox1 = testResult;
            // console.log("Problem 1 passed");
        } else {
            console.log("Test Failed for problem1: 'age' variable of type int is not declared correctly.");
        }


    }

    if (checkboxes.checkbox2 === false) {
        const testResult = expectedCode2.test(studentCode)
        if (testResult) {
            setProblemAsCompleted(lessonID + "P2", user.uid);
            checkboxes.checkbox2 = testResult;
            // console.log("Problem 2 passed");
        } else {
            console.log("Test Failed for problem 2: 'age' variable of type int is not declared correctly.");
        }
    }

    if (checkboxes.checkbox3 === false) {
        const testResult = expectedCode3.test(studentCode)
        if (testResult) {
            setProblemAsCompleted(lessonID + "P3", user.uid);
            checkboxes.checkbox3 = testResult;
            // console.log("Problem 3 passed");
        } else {
            console.log("Test Failed for problem 3: 'age' variable of type int is not declared correctly.");
        }
    }

    if (checkboxes.checkbox1 === true && checkboxes.checkbox2 === true && checkboxes.checkbox3 === true) {
        //  setLessonAsCompleted(lessonID, user.uid);
    }

    return checkboxes;
}